import { render, staticRenderFns } from "./IndicadoresResumoReaberta.vue?vue&type=template&id=3ecb35ad&scoped=true&"
import script from "./IndicadoresResumoReaberta.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoReaberta.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoReaberta.vue?vue&type=style&index=0&id=3ecb35ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb35ad",
  null
  
)

export default component.exports